import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Badge, Flex, Modal, Text } from '@mantine/core';

import { useGetPostReactors } from '../../../api/getPostReactors';

import { ReactorsModalContent } from './ReactorsModalContent';

type ReactorsModalProps = {
  postId: string;
};

export const ReactorsModal = NiceModal.create(({ postId }: ReactorsModalProps) => {
  const modal = useModal();

  const { data, isLoading, error } = useGetPostReactors({
    postId,
    config: { enabled: modal.visible },
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.55, blur: 3 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      size="sm"
      padding="lg"
      title={
        <Flex align="center" gap="sm">
          <Text fw={600} size="md">
            REACTORS
          </Text>
          {data && (
            <Badge variant="light" color="blue" size="sm">
              {data.length}
            </Badge>
          )}
        </Flex>
      }
    >
      <ReactorsModalContent data={data} isLoading={isLoading} error={error} />
    </Modal>
  );
});
